module.exports = __webpack_public_path__ + "img/31200.886b61d0.jpg";